import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const options = { role: ROLE.BUSINESS };

const path = "business/common";

export const List = async () => {
  return await axiosInstance(options).get(`${path}/faqs`);
};
